import React from 'react';

const Card = ({ children, className = '', padding = 'p-6', ...props }) => {
  return (
    <div 
      className={`bg-white border border-slate-200 shadow-sm ${padding} ${className}`}
      style={{ borderRadius: 'var(--radius-lg)' }}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
